import React from "react";
//import ReactGA from "react-ga";
//import { useRouteMatch } from "react-router";

const Analytics = () => {
    //const match = useRouteMatch()

    // ReactGA.initialize("UA-45454651");
    // ReactGA.set({ page: window.location.pathname });
    // ReactGA.pageview(window.location.pathname);

    return <div></div>
} 

export default Analytics;


// WEBPACK FOOTER //
// ./src/estimate_list/analytics.js